import * as React from 'react'

import { Box, HStack, SystemStyleObject, Text, VStack } from '@chakra-ui/react'

import { Link, Tooltip } from '@enechain/ecloud-designsystem'
import { FaCircleQuestionRegular } from '@enechain/ecloud-icons'

type Props = {
  label: string
  value: string | string[]
  to?: string | undefined
  itemFlex?: string
  styles?: SystemStyleObject
  valueStyles?: SystemStyleObject
  qLabel: string
  width?: string
  vWidth?: string
}

const RowContent: React.FC<Props> = ({
  label,
  value,
  to,
  itemFlex = '1',
  styles,
  valueStyles,
  qLabel,
  width = '150px',
  vWidth = '150px',
}) => {
  let content = Array.isArray(value) ? (
    <VStack align="start" gap="2" css={valueStyles}>
      {value.map((val, index) => (
        <Text key={index} textStyle="textMd" wordBreak="break-all">
          {val}
        </Text>
      ))}
    </VStack>
  ) : (
    <Text textStyle="textMd" wordBreak="break-all" css={valueStyles}>
      {value}
    </Text>
  )

  if (to !== undefined) {
    content = <Link href={to}>{content}</Link>
  }

  return (
    <HStack align="start" flex={itemFlex} gap="2" css={styles}>
      <HStack gap="2px" width={width}>
        <Text textStyle="headerSm">{label}</Text>
        <Tooltip label={qLabel}>
          <FaCircleQuestionRegular boxSize="16px" />
        </Tooltip>
      </HStack>
      <Box width={vWidth}>{content}</Box>
    </HStack>
  )
}

export default React.memo(RowContent)
